import { ChipProps, useTheme } from "@mui/material";
import { MprcChip, MprcChipProps } from "components/MprcChip";
import * as React from "react";

interface IProps extends MprcChipProps {
  selected?: boolean;
  selectedBgColor?: MprcColors;
  uppercase?: boolean;
  labelPadding?: number;
  margin?: number;
}

type Props = IProps & Omit<ChipProps, "color">;

export const MprcChipChoice: React.FC<Props> = (props) => {
  const { selected = false, selectedBgColor, labelPadding = 2, margin = .5, maxWidth = "270px", uppercase = false, ...rest } = props;

  const theme = useTheme();

  return (
    <MprcChip
      {...rest}
      maxWidth={maxWidth}
      sx={
        {
          ...props.sx,
          marginRight: theme.spacing(margin),
          marginLeft: theme.spacing(margin),
          marginBottom: theme.spacing(margin),
          backgroundColor: selected
            ? selectedBgColor
              ? theme.palette[selectedBgColor].main
              : theme.palette.highlight.main
            : "default",
          color: selected ? "white" : "default",
          textTransform: uppercase ? "uppercase" : undefined,
          "& .MuiChip-label": {
            paddingLeft: labelPadding,
            paddingRight: labelPadding
          },
          '& .MuiChip-avatar': {
            backgroundColor: 'transparent !important',
          },
          "&:hover": {
            color: "white",
            backgroundColor: selectedBgColor
              ? theme.palette[selectedBgColor].main
              : theme.palette.highlight.dark
          },
          "> .MuiChip-deleteIcon": {
            color: selected ? "white" : undefined
          }
        }
      }
    />
  );
};
